import React, { useEffect, useState } from 'react'
import DataLoader from '../../../Utils/DataLoader';
import { apiData } from '../../../actions';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";


export default function Winery() {
    const place = useSelector((state) => state.place);
    const formattedCity =
        place?.replace(/\b\w/g, (x) => x.toUpperCase()) || "";

    const [wineryDeal, setWineryDeal] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);

    const winery = async () => {
        let payload = {
            city: place,
            keyword: "Winery",
            limit: 12
        };

        setPageLoading(true);

        try {
            const apiRes = await apiData.getYelpDeals(payload);

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setWineryDeal(apiRes?.data?.data?.businesses || []);
            } else {
                setWineryDeal([]);
            }
        } catch (error) {
            console.error("Yelp API Error:", error);
            setWineryDeal([]);
        } finally {
            setPageLoading(false);
        }
    };

    useEffect(() => {
        winery();
    }, [place]);

    if (pageLoading) return <DataLoader />;
    return (
        <section className="section-equal-padding bg-white owl-nav-left" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="section-top-heading mb-3 mb-md-5 "
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: true">
                            <h2 className="mb-2 text-black">Winery</h2>
                            <p>
                                Get set for an awesome vacation! Explore sightseeing tours, bus excursions, and exclusive
                                passes. Uncover hidden gems, create memorable moments, and elevate your trip. Time to make
                                the most of it – book your tours now and let the adventure begin!
                            </p>
                        </div>
                    </div>
                </div>
                <div className="">
                    {wineryDeal && wineryDeal.length > 0 ?
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            navigation={true}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                992: { slidesPerView: 3 },
                                1400: { slidesPerView: 4 },
                            }}
                            className="excitement-swiper pb-70"
                        >
                            {wineryDeal.map((ele, index) => (
                                <SwiperSlide key={ele?.id || index} className="">
                                    <div className="resorts-box p-3 bg-white w-100">
                                        <figure>
                                            <img loading="lazy" src={ele?.image_url} alt="Winery" className="img-fluid" />
                                        </figure>
                                        <div className="resorts-content-box">
                                            <div className="resort-description p-0 m-0 border-0 d-flex justify-content-between">
                                                <h3>
                                                    {ele?.name?.length > 25
                                                        ? ele.name.slice(0, 30) + "..."
                                                        : ele.name}
                                                </h3>
                                                <span className="rating-star"><i className="fa-solid fa-star"></i>
                                                    {ele?.rating}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between flex-wrap row-gap-2 location-box">
                                                {/* <span className="rating-star calandor-icon"><i className="fa-solid fa-calendar"></i>
                                                    12/31/2022
                                                </span>
                                                <span className="rating-star"><i className="fa-solid fa-clock"></i>
                                                    07:30 PM
                                                </span> */}

                                                <span className="rating-star location-icon"><i className="fa-solid fa-location-dot"></i>
                                                    {ele?.location?.display_address[0]},{ele?.location?.display_address[1]}
                                                </span>
                                            </div>
                                            <div className="book-trip-btn">
                                                <a href={ele?.url} target="_blank" rel="noreferrer" className="w-100 text-center d-block">See More</a>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper> : `Oops! No Data Available ${`For ${formattedCity}`}`
                    }
                </div>
            </div>
        </section>
    )
}
